import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { BaseApiService } from '../base-api-service';
import { Application } from 'src/app/models/configurators-2d/administrations/application';
import { Project } from 'src/app/models/project';
import { parseUtcDateOrNull } from 'src/app/services/helpers/utc-date.helper';

@Injectable({
  providedIn: 'root',
})
export class ApplicationsService extends BaseApiService {
  constructor() {
    super(undefined);
  }

  /**
   * Fonction de récupération des admins par application
   */
  byDistribId(distribId: string): Promise<Application> {
    const params = new HttpParams().set('distribId', distribId);
    return this.get(this.apiUrl + 'application', params);
  }

  /**
   * Fonction de récupération des projets client
   * @param distribIds identifiant du configurateur
   * @returns liste des projets client
   */
  public async getProjects(distribIds: string[]): Promise<Project[]> {
    if (distribIds && distribIds.length > 0) {
      const params = new HttpParams().set('distribIds', JSON.stringify(distribIds));
      const res = await this.get(this.baseApiUrl + 'Projects', params);
      return res.map(project => ({
        projectUUID: project.id,
        projectID: project.id,
        projectName: project.title,
        dateUpdate: parseUtcDateOrNull(project.lastModificationTime),
        search: project.title.toLowerCase(),
        thumb: project.hasThumbnail ? project.picture : this.apiUrl + project.picture,
        distributionID: project.distribId,
        description: '',
        hasDiscount: project.hasDiscount,
        hasQuotation: project.hasQuotation,
        quotationExpirationDate: project.quotationExpirationDate,
        inTunnel: project.inTunnel,
        tunnelContext: project.tunnelContext,
        tunnelId: project.tunnelId,
      }));
    }
    
    return [];
  }
}
